import { TELECONSULT, CHAT_CONSULT } from 'Constants/service-types';
import { NotificationStatus } from 'Containers/Notification/constants';

import * as ACTION_TYPES from './types';

const compare = (item1, item2) => {
  const date1 = new Date(item1.createdAt);
  const date2 = new Date(item2.createdAt);
  return date2.valueOf() - date1.valueOf();
};

const initialState = {
  status: {
    register: -1,
    unregister: -1,
    listNoti: -1,
    badges: -1,
    readAll: -1,
    readNoti: -1,
    seenAll: -1,
  },
  badges: 0,
  listNoti: [],
  moreNoti: [],
  error: {
    badges: null,
    listNoti: null,
    readAll: null,
    readNoti: null,
    seenAll: null,
    register: null,
  },
};

export default function reducer(state = initialState, action) {
  const { type, error, payload } = action;
  const ids = state.listNoti?.map(noti => noti.id) || [];
  switch (type) {
    // registerDevice
    case ACTION_TYPES.NOTIFICATION_REGISTER_DEVICE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          register: 0,
        },
        error: {
          ...state.error,
          register: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_REGISTER_DEVICE_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          register: 1,
        },
        error: {
          ...state.error,
          register: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_REGISTER_DEVICE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          register: 2,
        },
        error: {
          ...state.error,
          register: error,
        },
      };

    // case ACTION_TYPES.ALERT_DEVICE_UNREGISTER_REQUESTED:
    //   return {
    //     ...state,
    //     status: {
    //       ...state.status,
    //       unregister: 0,
    //     },
    //     error: null,
    //   };
    //
    // case ACTION_TYPES.ALERT_DEVICE_UNREGISTER_SUCCESS:
    //   return {
    //     ...state,
    //     status: {
    //       ...state.status,
    //       unregister: 1,
    //     },
    //   };
    //
    // case ACTION_TYPES.ALERT_DEVICE_UNREGISTER_FAILED:
    //   return {
    //     ...state,
    //     status: {
    //       ...state.status,
    //       unregister: 2,
    //     },
    //     error,
    //   };

    // getNotifications
    case ACTION_TYPES.NOTIFICATION_GET_LIST_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          listNoti: 0,
        },
        error: {
          ...state.error,
          listNoti: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_GET_LIST_SUCCESS:
      return {
        ...state,
        listNoti: [
          ...state.listNoti,
          ...(payload?.data || [])
            .filter(e => !ids.includes(e.id))
            .filter(e => ![TELECONSULT, CHAT_CONSULT].includes(e.service)),
        ].sort(compare),
        moreNoti: payload?.data || [],
        status: {
          ...state.status,
          listNoti: 1,
        },
      };

    case ACTION_TYPES.NOTIFICATION_GET_LIST_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          listNoti: 2,
        },
        error: {
          ...state.error,
          listNoti: error,
        },
      };

    // getBadges
    case ACTION_TYPES.NOTIFICATION_GET_BADGES_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          badges: 0,
        },
        error: {
          ...state.error,
          badges: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_GET_BADGES_SUCCESS:
      return {
        ...state,
        badges: payload?.data?.badgeCount || 0,
        status: {
          ...state.status,
          badges: 1,
        },
      };

    case ACTION_TYPES.NOTIFICATION_GET_BADGES_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          badges: 2,
        },
        error: {
          ...state.error,
          badges: error,
        },
      };

    // readAllNotifications
    case ACTION_TYPES.NOTIFICATION_READ_ALL_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          readAll: 0,
        },
        error: {
          ...state.error,
          readAll: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_READ_ALL_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          readAll: 1,
        },
        listNoti: state.listNoti.map(e => ({ ...e, status: NotificationStatus.READ })),
      };

    case ACTION_TYPES.NOTIFICATION_READ_ALL_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          readAll: 2,
        },
        error: {
          ...state.error,
          readAll: error,
        },
      };

    // readNotification
    case ACTION_TYPES.NOTIFICATION_READ_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          readNoti: 0,
        },
        error: {
          ...state.error,
          readNoti: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_READ_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          readNoti: 1,
        },
        // update read noti status
        listNoti: state.listNoti.map(e => (payload?.data?.id === e.id ? payload?.data : e)),
      };

    case ACTION_TYPES.NOTIFICATION_READ_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          readNoti: 2,
        },
        error: {
          ...state.error,
          readNoti: error,
        },
      };

    // seenAllNotifications
    case ACTION_TYPES.NOTIFICATION_SEEN_ALL_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          seenAll: 0,
        },
        error: {
          ...state.error,
          seenAll: null,
        },
      };

    case ACTION_TYPES.NOTIFICATION_SEEN_ALL_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          seenAll: 1,
        },
        // Only update new to seen
        listNoti: state.listNoti.map(e => ({
          ...e,
          status: e.status === NotificationStatus.READ ? e.status : NotificationStatus.SEEN,
        })),
        // reset badges
        badges: 0,
      };

    case ACTION_TYPES.NOTIFICATION_SEEN_ALL_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          seenAll: 2,
        },
        error: {
          ...state.error,
          seenAll: error,
        },
      };

    case ACTION_TYPES.ALERT_LIST_CLEAR:
      return {
        ...state,
        listNoti: [],
      };

    case ACTION_TYPES.ALERT_MINUS:
      return {
        ...state,
        badges: state.badges > 0 ? state.badges - 1 : 0,
      };

    default:
      return state;
  }
}
